import React from "react";
import DownloadPackage from "../../Components/Tracking/DownloadPackage";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const DownloadPackagePage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <DownloadPackage date={query.date} />
    </React.Fragment>
  );
};

export default DownloadPackagePage;
